import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

const PendingLoan = () => {
  return (
    <div className="">
      {/* Search Bar */}
      <div className="mt-4">
        <input
          type="text"
          placeholder="Search by name"
          className="w-full border rounded-md p-2 text-sm"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-100 text-gray-600">
            <tr>
              <th className="py-2 px-4">Request ID</th>
              <th className="py-2 px-4">Business Name</th>
              <th className="py-2 px-4">Borrower Name</th>
              <th className="py-2 px-4">Requested Amount</th>
              <th className="py-2 px-4">Proposed repayment amount</th>
              <th className="py-2 px-4">Requested loan term</th>
              <th className="py-2 px-4">Lender name</th>
              <th className="py-2 px-4">Request date</th>
              <th className="py-2 px-4">Status</th>
              <th className="py-2 px-4">Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {[].map((loan, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{loan.id}</td>
                <td className="py-2 px-4">{loan.amount}</td>
                <td className="py-2 px-4">{loan.repayment}</td>
                <td className="py-2 px-4">{loan.applied}</td>
                <td className="py-2 px-4">{loan.due}</td>
                <td className="py-2 px-4 flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-orange-400"></span>
                  {loan.status}
                </td>
                <td className="py-2 px-4 text-center">
                  <button className="bg-blue-100 text-blue-600 p-2 rounded-full">
                    <VisibilityIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingLoan;
